"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Main =
/*#__PURE__*/
function (_View) {
  (0, _inherits2["default"])(Main, _View);

  function Main() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Main);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Main)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hidden: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hide", function () {
      return _this.setState({
        hidden: true
      });
    });
    return _this;
  }

  return Main;
}(_Component["default"]);

(0, _defineProperty2["default"])(Main, "defaultProps", {
  closeAvailable: true,
  multiline: true
});
(0, _defineProperty2["default"])(Main, "propTypes", {
  closeAvailable: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  children: _propTypes["default"].any,
  icon: _propTypes["default"].any,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default block
     */
    display: _propTypes["default"].string,

    /**
     * @default ${palette.gutter}px ${palette.gutter * 5}px ${palette.gutter}px ${palette.gutter}px
     */
    padding: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default 1px solid ${palette.elPrimary}
     */
    border: _propTypes["default"].string,

    /**
     * @default 0 8px 12px 0 ${palette.elShadow}, 0 6px 12px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default palette.zOverlay
     */
    zIndex: _propTypes["default"].number,

    /**
     * @default palette.tError
     */
    color: _propTypes["default"].string,

    /**
     * @default Close
     */
    closeIcon: _propTypes["default"].func,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    maxWidth: _propTypes["default"].string,

    /**
     * @default 2px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default left
     */
    textAlign: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Main, "displayName", 'ErrorHint');
var _default = Main;
exports["default"] = _default;